/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignLeft = createReactComponent("outline", "align-left", "IconAlignLeft", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M4 12l10 0", "key": "svg-1" }], ["path", { "d": "M4 18l14 0", "key": "svg-2" }]]);

export { IconAlignLeft as default };
//# sourceMappingURL=IconAlignLeft.mjs.map
